module.exports = __webpack_public_path__ + "static/logo_111_183-35588d44878d437cc0ad8f7f943498ad.png";